
import Vue from 'vue'
import { SignInRefused, signIn } from '../signin'

// The form is the view's whole job and none of its logic: what to send, what a
// refusal says and where a signed-in user lands are `../signin`, which is where
// the tests are. What is here is the two fields, the message, and the button
// that keeps the form from being submitted twice.
export default Vue.extend({
  name: 'SignIn',

  data: () => ({
    identifier: '',
    password: '',
    showPassword: false,
    signingIn: false,
    refusal: ''
  }),

  methods: {
    async submit () {
      this.signingIn = true
      this.refusal = ''

      try {
        await signIn(this.identifier, this.password)
      } catch (error) {
        this.refusal = error instanceof SignInRefused
          ? error.message
          : 'Something went wrong signing you in. Please try again.'

        // Cleared rather than left in the field: it has already been refused, and
        // keeping it about for the next attempt is not a kindness. The identifier
        // stays, because correcting it is usually what the user is about to do.
        this.password = ''
      } finally {
        this.signingIn = false
      }
    }
  }
})
